/**
 * Moduł umożliwiający opłacenie zaległej składki za subskrypcje
 * Obsługuje interakcje związane z wyborem płatności tPay, płatność kartą, BLIK
 */
app.service('subscriptionOverduePayment', function (loading, modal, ePaymentBlikModal, subscriptionMpcBlikPayment) {

	const getRecurringPaymentId = element => $(element).closest('.subscription-item').data('id');
	const getSubscriptionItemParent = recurringPaymentId => $(`.subscription-item[data-id="${recurringPaymentId}"]`);

	function init() {
		setEvents();
	}

	function setEvents() {
		$('body')
			.on('click', '.js-select-overdue-payment', function () {
				const paymentTypeName = $(this).data('name');
				const recurringPaymentId = getRecurringPaymentId(this);
				selectOverduePaymentType(paymentTypeName, recurringPaymentId);
				checkValidation(recurringPaymentId);
			})
			.on('click', '.js-pay-overdue-subscription-fee', function () {
				const recurringPaymentId = getRecurringPaymentId(this);
				if (checkValidation(recurringPaymentId)) {
					sendOverduePayment(recurringPaymentId, $(this).data('payment-id'), $(this).data('product-type'));
				}
			})
			.on('click', '.js-bank-select', function () {
				$('.js-bank-select', $(this).parent()).removeClass('selected');
				$(this).addClass('selected');
				checkValidation(getRecurringPaymentId(this));
			})
			.on('click', '.terms-list input[name="paymentOperatorAgreementAccepted"]', function () {
				checkValidation(getRecurringPaymentId(this));
			});
	}

	function selectOverduePaymentType(paymenTypeName, recurringPaymentId) {
		const $subscriptionBox = getSubscriptionItemParent(recurringPaymentId);
		const $paymentButtons = $('.js-select-overdue-payment', $subscriptionBox);
		const $selectedPaymentButton = $(`.js-select-overdue-payment[data-name="${paymenTypeName}"]`, $subscriptionBox);
		const $selectedPaymentAdditionalSection = $('.overdue-selected-payment-section', $subscriptionBox);

		$paymentButtons.removeClass('selected');
		$selectedPaymentButton.addClass('selected');
		$selectedPaymentAdditionalSection.attr('data-payment-type', paymenTypeName);
	}

	function sendOverduePayment(recurringPaymentId, paymentId, productType) {
		const $subscriptionBox = getSubscriptionItemParent(recurringPaymentId);
		const paymentType = $('.js-select-overdue-payment.selected', $subscriptionBox).data('name');
		const termsAccepted = $('input[name="paymentOperatorAgreementAccepted"]', $subscriptionBox).is(':checked');
		const tpayBankCode = $('.js-bank-select.selected', $subscriptionBox).data('tpaycode');
		let data = {
			paymentId: paymentId,
			paymentType: paymentType,
			productType,
			termsAccepted: termsAccepted
		}
		if (paymentType === 'E_TRANSFER') {
			data.tpayBankCode = tpayBankCode;
		}
		if (paymentType === 'BLIK') {
			ePaymentBlikModal.load('MPC', '', function (inputBlikCode) {
				data.blikCode = inputBlikCode;
				data.recurringPaymentId = recurringPaymentId;
				goToPayment(data);
			});
		} else {
			goToPayment(data);
		}
	}

	function goToPayment(data) {
		loading.start();
		$.ajax({
			url: '/customer-subscription-payment-by-link.ltr',
			type: 'POST',
			contentType: 'application/json',
			data: JSON.stringify(data),
			success: (response) => {
				loading.stop();
				if (response.status === 'SUCCESS') {

					if (response.redirectUrl === '') {
						// procesujemy odpytywanie o BLIKA przez MPC
						subscriptionMpcBlikPayment.init(data);
					} else {
						// REDIRECT to TPAY page
						modal.open('redirect-to-payment', {
							closeOnOutsideClick: false,
							closeOnEscape: false,
						});
						//sztucznie opóźniamy przekierowanie, żeby klient mógł zobaczyć modal
						setTimeout(function () {
							loading.redirect(response.redirectUrl);
						}, 2000);
					}

				} else {
					modal.alert('Wystąpił błąd podczas weryfikacji danych płatności');
				}
			},
			error: () => {
				loading.stop();
				modal.alert('Wystąpił błąd komunikacji, prosimy spróbować później');
			},
		});
	}

	function checkValidation(recurringPaymentId) {
		let valid = false;
		const $subscriptionBox = getSubscriptionItemParent(recurringPaymentId);
		const $payOverdueSubscriptionButton = $('.js-pay-overdue-subscription-fee', $subscriptionBox);
		const paymentType = $('.js-select-overdue-payment.selected', $subscriptionBox).data('name');
		const termsAccepted = $('input[name="paymentOperatorAgreementAccepted"]', $subscriptionBox).is(':checked');
		const tpayBankCode = $('.js-bank-select.selected', $subscriptionBox).data('tpaycode');

		if (paymentType && termsAccepted && !(paymentType === 'E_TRANSFER' && !tpayBankCode) || paymentType === 'E_CARD') {
			valid = true;
		}

		$payOverdueSubscriptionButton.attr('disabled', !valid);
		return valid;
	}

	return {
		init
	}
});